
import {aleas} from './aleas.schema.js'

import {const_coherenceengins} from './constCoherenceEngins.schema.js'
import {const_constantes} from './constConstantes.schema.js'
import {const_cubaturestypes} from './constCubaturestypes.schema.js'
import {const_cubaturestypes_const_phases} from './constCubaturestypesconstPhases.schema.js'
import {const_engins} from './constEngins.schema.js'
import {const_engins_const_parametresmateriels} from './constEngins_constParametresmateriels.schema.js'
import {const_enginsvaleurparametres} from './constEnginsvaleurparametres.schema.js'

//import {const_enginsplus} from './constEnginsPlus.schema.js'

import {const_equipementsprestations} from './constEquipementsprestations.schema.js'
import {const_famillesengins} from './constFamillesengins.schema.js'
import {const_famillesengins_const_options_const_phases} from './constFamillesengins_constOptions_constPhases.schema.js'
import {const_famillesengins_const_parametresmateriels} from './constFamillesengins_constParametresmateriels.schema.js'
import {const_godets} from './constGodets.schema.js'
import {const_humidites} from './constHumidites.schema.js'
import {const_installations} from './constInstallations.schema.js';
import {const_options} from './constOptions.schema.js'
import {const_parametresmateriels} from './constParametresmateriels.schema.js'
import {const_phases} from './constPhases.schema.js'
import {const_sols} from './constSols.schema.js'
import {const_usagesengins} from './constUsagesEngins.schema.js'
import {const_usagesengins_const_usagesengins} from './constUsagesenginsconstUsagesengins.schema.js'

import { exo_chantiers } from './exoChantiers.schema.js'
import { exo_cubatures } from './exoCubatures.schema.js'
import { exo_cubatures_exo_mouvements } from './exoCubatures_exoMouvements.schema.js'
import { exo_mouvements } from './exoMouvements.schema.js'

import { simu_analyses } from './simuAnalyses.schema.js'
import { simu_cubatures } from './simuCubatures.schema.js'
import { simu_echelons } from './simuEchelons.schema.js'
import { simu_echelons_simu_engins } from './simuEchelons_simuEngins.schema.js'
import { simu_eleves } from './simuEleves.schema.js'
import { simu_engins } from './simuEngins.schema.js'
import { simu_etudes } from './simuEtudes.schema.js'
import { simu_etudes_exo_cubatures_exo_mouvements } from './simuEtudes_exoCubatures_exoMouvements.schema.js'
import { simu_installations } from './simuInstallations.schema.js'
import { simu_installations_const_installations} from './simuInstallations_constInstallations.schema.js'
import { simu_mouvements } from './simuMouvements.schema.js'

// BC 2019/02 : cet import peut-il être rendu facultatif ?
import { simuexo_chantiers } from './simuexoChantiers.schema.js'
import { simuexo_cubatures } from './simuexoCubatures.schema.js'
import { simuexo_cubatures_couches } from './simuexoCubaturesCouches.schema.js'
import { simuexo_mouvements } from './simuexoMouvements.schema.js'
import { simuexo_mouvements_simuexo_cubatures } from './simuexoMouvements_simuexoCubatures.schema.js'
//import { simuexo_cubatures_simuexo_cubatures } from './simuexoCubatures_simuexoCubatures.schema.js'

// import { exampleEchelon } from './example_echelon.schema.js'

/*
Passage du schemaBuilder à chaque table listée ici
*/
export function generateSchemas(schemaBuilder) {

  aleas(schemaBuilder);
  
  const_coherenceengins(schemaBuilder);
  const_constantes(schemaBuilder);
  const_cubaturestypes(schemaBuilder);
  const_cubaturestypes_const_phases(schemaBuilder);
  const_engins(schemaBuilder);
  //const_enginsplus(schemaBuilder);
  const_enginsvaleurparametres(schemaBuilder);
  const_engins_const_parametresmateriels(schemaBuilder);
  const_equipementsprestations(schemaBuilder);
  const_famillesengins(schemaBuilder);
  const_famillesengins_const_options_const_phases(schemaBuilder);
  const_famillesengins_const_parametresmateriels(schemaBuilder);
  const_godets(schemaBuilder);
  const_humidites(schemaBuilder);
  const_installations(schemaBuilder);
  const_options(schemaBuilder);
  const_parametresmateriels(schemaBuilder);
  const_phases(schemaBuilder);
  const_sols(schemaBuilder);
  const_usagesengins(schemaBuilder);
  const_usagesengins_const_usagesengins(schemaBuilder);
  exo_chantiers(schemaBuilder);
  exo_cubatures(schemaBuilder);
  exo_cubatures_exo_mouvements(schemaBuilder);
  exo_mouvements(schemaBuilder);
  simu_analyses(schemaBuilder);
  simu_cubatures(schemaBuilder);
  simu_echelons(schemaBuilder);
  simu_echelons_simu_engins(schemaBuilder);
  simu_eleves(schemaBuilder);
  simu_engins(schemaBuilder);
  simu_etudes(schemaBuilder);
  simu_etudes_exo_cubatures_exo_mouvements(schemaBuilder);
  simu_installations(schemaBuilder);
  simu_installations_const_installations(schemaBuilder);
  simu_mouvements(schemaBuilder);

// BC 2019/02 : cette action peut-elle être rendue facultative ?
  simuexo_chantiers(schemaBuilder);
  simuexo_cubatures(schemaBuilder);
  simuexo_cubatures_couches(schemaBuilder);
  simuexo_mouvements(schemaBuilder);
  simuexo_mouvements_simuexo_cubatures(schemaBuilder);

  // simuexo_cubatures_simuexo_cubatures(schemaBuilder);

  // Example
 // exampleEchelon(schemaBuilder);

}



// WEBPACK FOOTER //
// ./src/client/common/db/schemas/index.js